import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import { getRoutes } from "./getRoutes";
import cloneDeep from "lodash/cloneDeep";
const Login = () => import("../views/Login");
const SSOLogin = () => import("../views/SSOLogin");
const Layout = () => import("../components/layout");
import { logout, } from "@/api/login";
import { getRouters } from "@/api/menu";
import Cookies from "js-cookie";
import { isRelogin } from '@/utils/request'

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  return originalPush.call(this, location).catch((err) => err);
};
const loginPath = `/Login`;
const routes = [
  {
    path: "/",
    redirect: "/Layout",
  },
  {
    path: loginPath,
    name: "Login",
    component: Login,
  },
  {
    path: "/Layout",
    name: "Layout",
    component: Layout,
    children: [
      {
        path: "/404",
        name: "404",
        component: () => import("../views/NotFind"),
      },
    ],
  },
  {
    path: `/SSOLogin`,
    name: "SSOLogin",
    component: SSOLogin,
  }
];

const router = new VueRouter({
  mode: "history",
  // mode:'hash',
  base: process.env.VUE_APP_WEB_PREFIX,
  routes,
});
const globalPaths = ["Login", "Layout", "Home"];
const whiteList = ['/Login', '/register', '/SSOLogin']
const localRoutes = [
  // 设备管理
  "DeviceManagement",
  // 设备信息
  "DeviceMsg",
  // 初始化外部设备
  "DeviceOutInit",
  // 外设管理
  "DeviceOutManagement",
  // 部署管理
  "DeployManagement",
  // 业务数据管理
  "BusinessDataManagement",
  // 上传补救策略
  "BusinessDataUploadRemedy",
  // 日志查看
  "SeeLog",
  // 云端日志查看
  "SeeCloudLog",
  // 业务数据监控
  "BusinessDataMonitor",
  // 业务数据统计
  "BusinessDataStatistics",
  // 企业分组统计
  "BusinessDataGroupStatistics",
  // 上传补救策略
  "BusinessDataUploadRemedy",
  // 采集端日志
  "CollectionLog",
  // 参数设置管理
  "ParamsSetAndSync",
  // 历史参数
  "HistoryParameter",
  // 参数设置与同步
  "HandleCodeParamsSetAndSync",
  // 设备运行管理
  "DeviceRunManagement",
  // 设备状态管理
  "DeviceStatusManagement",
  // 电子秤主题库
  "ElectronicScaleThemeLibrary",
  // 卷标号管理与验证
  "SignManagementAndCheck",
  // 采集器系统省级管理
  "CollectionSystemSetUpManagement",
  // 升级管理
  "UpdateManagement",
  // 发布名单设置
  "ReleaseNameListSetUp",
  // 已升级设备列表
  "UpdatedDeviceList",
];

function addChildrenMenu(menu, routes) {
  menu?.forEach((item) => {
    if (item.path?.indexOf("/") === 0) {
      routes.push(item.path.substr(1));
    }
    if (item.children && item.children.length > 0) {
      addChildrenMenu(item.children, routes)
    }
  });
}

router.beforeEach(async (to, from, next) => {
  if (store.state.token) {
    if (to.path === '/Login' || to.path === '/SSOLogin') {
      next()
    } else {
      if (store.state.userStore.roles.length === 0) {
        isRelogin.show = true
        try {
          let dataRes = await getRouters()
          isRelogin.show = false
          store.commit("setUserMsg", dataRes.user);
          store.commit("SET_ROLES", dataRes.roles.length === 0 ? ['ROLE_DEFAULT'] : dataRes.roles);
          store.commit("setPerm", dataRes.permissions);
          const routes = [];
          addChildrenMenu(dataRes.data, routes)
          store.commit("setMenus", routes);
          store.commit("setRoutes");
          next({ ...to, replace: true })
        } catch (error) {
          logout().finally(() => {
            store.commit('logout')
          })
        }
      } else {
        next()
      }
    }
  } else {
     // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next({ path: loginPath });
    }
  }
  // 没有token 
  // if (!store.state.token && to.path !== loginPath) {
  //   next({
  //     path: loginPath,
  //   });
  // } else {
  //   console.log(store.state.menus);
  //   const menus = [...store.state.menus, ...globalPaths];
  //   if (!menus.includes(to.name) && to.path !== "/404") {
  //     next({
  //       path: "/404",
  //     });
  //   } else {
  //     next();
  //   }
  // }
});


export const handleRoutes = (keys) => {
  const children = getRoutes(keys);
  const _routes = cloneDeep(routes);
  if (children.length > 0) {
    const item = _routes.find((a) => a.name === "Layout");
    item.redirect = children[0].path;
    item.children = children;
  }
  router.options.routes = _routes;
  router.matcher = new VueRouter({
    mode: "history",
  }).matcher;
  router.addRoutes(_routes);
};
store.commit("setRoutes");
export default router;
